// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base reset and variables */
:root {
    --gunmetal: rgb(41, 47, 54);
    --robin-egg: rgb(78, 205, 196);
    --white: rgb(255, 255, 255);
    --glass-bg: rgba(255, 255, 255, 0.1);
    --glass-border: rgba(255, 255, 255, 0.18);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

/* Mobile-first base styles */
body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-family: Arial, sans-serif;
    line-height: 1.6;
    color: var(--white);
    min-height: 100vh;
    padding: 1rem;
    background: linear-gradient(135deg, var(--gunmetal) 0%, var(--robin-egg) 100%);
}

/* Glass container effect */
#app {
    flex: 1;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    padding: 1.5rem;
    background: var(--glass-bg);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(8.5px);
    -webkit-backdrop-filter: blur(8.5px);
    border: 1px solid var(--glass-border);
}

/* Form styling */
#locationForm {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;
}

#locationForm label {
    font-weight: bold;
    color: var(--white);
    font-size: 1.1rem;
}

#locationForm input {
    width: 100%;
    padding: 0.8rem;
    border: 2px solid var(--glass-border);
    border-radius: 12px;
    font-size: 1rem;
    background: rgba(255, 255, 255, 0.05);
    color: var(--white);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

#locationForm input:focus {
    outline: none;
    border-color: var(--robin-egg);
    box-shadow: 0 0 0 2px rgba(78, 205, 196, 0.2);
}

#locationForm input::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

#locationForm button {
    width: 100%;
    padding: 0.8rem;
    background-color: var(--robin-egg);
    color: var(--gunmetal);
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    transition: all 0.3s ease;
}

#locationForm button:hover {
    background-color: rgba(78, 205, 196, 0.8);
    transform: translateY(-2px);
}

/* Headings */
h1, h2 {
    color: var(--robin-egg);
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
    border-bottom: 2px solid rgba(78, 205, 196, 0.3);
    padding-bottom: 0.5rem;
}

/* Weather information */
p {
    margin: 0.8rem 0;
    font-size: 1rem;
    color: var(--white);
}

/* Weather GIF styling */
.weather-gif {
    margin: 1.5rem 0;
    text-align: center;
}

.weather-gif img {
    max-width: 100%;
    height: auto;
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

/* Forecast sections */
div:has(> h2:contains("Forecast")) div {
    padding: 1rem;
    margin: 1rem 0;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 12px;
    border-left: 4px solid var(--robin-egg);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

/* Loading overlay */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(41, 47, 54, 0.9);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(5px);
}

/* Loading spinner */
.loader {
    width: 50px;
    height: 50px;
    border: 5px solid rgba(78, 205, 196, 0.3);
    border-radius: 50%;
    border-top-color: rgb(78, 205, 196);
    animation: spin 1s ease-in-out infinite;
    margin: 0 auto;
}

.loader-text {
    color: rgb(78, 205, 196);
    text-align: center;
    margin-top: 20px;
    font-size: 1.2rem;
}

/* Weather Icons */
.weather-icon {
    display: flex;
    justify-content: center;
    margin: 10px;
    padding: 10px;
    width: 50px;
    height: 50px;
    background-size: contain;
    background-repeat: no-repeat;
}

/* Icon Mappings */
.weather-icon.snow { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/snow.svg'); }
.weather-icon.snow-showers-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/snow-showers-day.svg'); }
.weather-icon.snow-showers-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/snow-showers-night.svg'); }
.weather-icon.thunder-rain { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/thunder-rain.svg'); }
.weather-icon.thunder-showers-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/thunder-showers-day.svg'); }
.weather-icon.thunder-showers-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/thunder-showers-night.svg'); }
.weather-icon.rain { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/rain.svg'); }
.weather-icon.showers-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/showers-day.svg'); }
.weather-icon.showers-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/showers-night.svg'); }
.weather-icon.fog { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/fog.svg'); }
.weather-icon.wind { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/wind.svg'); }
.weather-icon.cloudy { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/cloudy.svg'); }
.weather-icon.partly-cloudy-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/partly-cloudy-day.svg'); }
.weather-icon.partly-cloudy-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/partly-cloudy-night.svg'); }
.weather-icon.clear-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/clear-day.svg'); }
.weather-icon.clear-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/clear-night.svg'); }

footer {
    background-color: var(--gunmetal);
    color: var(--white);
    text-align: center;
    padding: 1rem;
    width: 100%;
    margin-top: auto;
}

.social-links {
    margin-top: 0.5rem;
}

.social-links a {
    color: var(--robin-egg);
    font-size: 1.5rem;
    transition: color 0.3s ease;
    text-decoration: none;
    margin: 0 0.5rem;
}

.social-links a:hover {
    color: rgba(78, 205, 196, 0.3);
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

/* Hide loader by default */
.hidden {
    display: none;
}

/* Desktop styles */
@media (min-width: 768px) {
    body {
        padding: 2rem;
    }

    #app {
        max-width: 800px;
        padding: 2rem;
    }

    h1, h2 {
        font-size: 1.8rem;
    }

    p {
        font-size: 1.1rem;
    }

    .weather-gif img {
        max-width: 80%;
    }
}`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,2BAA2B;IAC3B,oCAAoC;IACpC,yCAAyC;AAC7C;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,8EAA8E;AAClF;;AAEA,2BAA2B;AAC3B;IACI,OAAO;IACP,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;IACnB,yCAAyC;IACzC,4BAA4B;IAC5B,oCAAoC;IACpC,qCAAqC;AACzC;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,mBAAmB;IACnB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,6CAA6C;AACjD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kCAAkC;IAClC,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,2BAA2B;AAC/B;;AAEA,aAAa;AACb;IACI,uBAAuB;IACvB,qBAAqB;IACrB,iBAAiB;IACjB,gDAAgD;IAChD,sBAAsB;AAC1B;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,mBAAmB;IACnB,uCAAuC;IACvC,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,0BAA0B;AAC9B;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,kBAAkB;IAClB,mCAAmC;IACnC,uCAAuC;IACvC,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA,kBAAkB;AAClB,qBAAqB,8HAA8H,EAAE;AACrJ,iCAAiC,0IAA0I,EAAE;AAC7K,mCAAmC,4IAA4I,EAAE;AACjL,6BAA6B,sIAAsI,EAAE;AACrK,oCAAoC,6IAA6I,EAAE;AACnL,sCAAsC,+IAA+I,EAAE;AACvL,qBAAqB,8HAA8H,EAAE;AACrJ,4BAA4B,qIAAqI,EAAE;AACnK,8BAA8B,uIAAuI,EAAE;AACvK,oBAAoB,6HAA6H,EAAE;AACnJ,qBAAqB,8HAA8H,EAAE;AACrJ,uBAAuB,gIAAgI,EAAE;AACzJ,kCAAkC,2IAA2I,EAAE;AAC/K,oCAAoC,6IAA6I,EAAE;AACnL,0BAA0B,mIAAmI,EAAE;AAC/J,4BAA4B,qIAAqI,EAAE;;AAEnK;IACI,iCAAiC;IACjC,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA,2BAA2B;AAC3B;IACI,aAAa;AACjB;;AAEA,mBAAmB;AACnB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/* Base reset and variables */\n:root {\n    --gunmetal: rgb(41, 47, 54);\n    --robin-egg: rgb(78, 205, 196);\n    --white: rgb(255, 255, 255);\n    --glass-bg: rgba(255, 255, 255, 0.1);\n    --glass-border: rgba(255, 255, 255, 0.18);\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n/* Mobile-first base styles */\nbody {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    font-family: Arial, sans-serif;\n    line-height: 1.6;\n    color: var(--white);\n    min-height: 100vh;\n    padding: 1rem;\n    background: linear-gradient(135deg, var(--gunmetal) 0%, var(--robin-egg) 100%);\n}\n\n/* Glass container effect */\n#app {\n    flex: 1;\n    width: 100%;\n    max-width: 100%;\n    margin: 0 auto;\n    padding: 1.5rem;\n    background: var(--glass-bg);\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    backdrop-filter: blur(8.5px);\n    -webkit-backdrop-filter: blur(8.5px);\n    border: 1px solid var(--glass-border);\n}\n\n/* Form styling */\n#locationForm {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 2rem;\n}\n\n#locationForm label {\n    font-weight: bold;\n    color: var(--white);\n    font-size: 1.1rem;\n}\n\n#locationForm input {\n    width: 100%;\n    padding: 0.8rem;\n    border: 2px solid var(--glass-border);\n    border-radius: 12px;\n    font-size: 1rem;\n    background: rgba(255, 255, 255, 0.05);\n    color: var(--white);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n}\n\n#locationForm input:focus {\n    outline: none;\n    border-color: var(--robin-egg);\n    box-shadow: 0 0 0 2px rgba(78, 205, 196, 0.2);\n}\n\n#locationForm input::placeholder {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n#locationForm button {\n    width: 100%;\n    padding: 0.8rem;\n    background-color: var(--robin-egg);\n    color: var(--gunmetal);\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: bold;\n    transition: all 0.3s ease;\n}\n\n#locationForm button:hover {\n    background-color: rgba(78, 205, 196, 0.8);\n    transform: translateY(-2px);\n}\n\n/* Headings */\nh1, h2 {\n    color: var(--robin-egg);\n    margin-bottom: 1.5rem;\n    font-size: 1.5rem;\n    border-bottom: 2px solid rgba(78, 205, 196, 0.3);\n    padding-bottom: 0.5rem;\n}\n\n/* Weather information */\np {\n    margin: 0.8rem 0;\n    font-size: 1rem;\n    color: var(--white);\n}\n\n/* Weather GIF styling */\n.weather-gif {\n    margin: 1.5rem 0;\n    text-align: center;\n}\n\n.weather-gif img {\n    max-width: 100%;\n    height: auto;\n    border-radius: 16px;\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n}\n\n/* Forecast sections */\ndiv:has(> h2:contains(\"Forecast\")) div {\n    padding: 1rem;\n    margin: 1rem 0;\n    background: rgba(255, 255, 255, 0.05);\n    border-radius: 12px;\n    border-left: 4px solid var(--robin-egg);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n}\n\n/* Loading overlay */\n.loading-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(41, 47, 54, 0.9);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    backdrop-filter: blur(5px);\n}\n\n/* Loading spinner */\n.loader {\n    width: 50px;\n    height: 50px;\n    border: 5px solid rgba(78, 205, 196, 0.3);\n    border-radius: 50%;\n    border-top-color: rgb(78, 205, 196);\n    animation: spin 1s ease-in-out infinite;\n    margin: 0 auto;\n}\n\n.loader-text {\n    color: rgb(78, 205, 196);\n    text-align: center;\n    margin-top: 20px;\n    font-size: 1.2rem;\n}\n\n/* Weather Icons */\n.weather-icon {\n    display: flex;\n    justify-content: center;\n    margin: 10px;\n    padding: 10px;\n    width: 50px;\n    height: 50px;\n    background-size: contain;\n    background-repeat: no-repeat;\n}\n\n/* Icon Mappings */\n.weather-icon.snow { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/snow.svg'); }\n.weather-icon.snow-showers-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/snow-showers-day.svg'); }\n.weather-icon.snow-showers-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/snow-showers-night.svg'); }\n.weather-icon.thunder-rain { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/thunder-rain.svg'); }\n.weather-icon.thunder-showers-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/thunder-showers-day.svg'); }\n.weather-icon.thunder-showers-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/thunder-showers-night.svg'); }\n.weather-icon.rain { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/rain.svg'); }\n.weather-icon.showers-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/showers-day.svg'); }\n.weather-icon.showers-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/showers-night.svg'); }\n.weather-icon.fog { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/fog.svg'); }\n.weather-icon.wind { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/wind.svg'); }\n.weather-icon.cloudy { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/cloudy.svg'); }\n.weather-icon.partly-cloudy-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/partly-cloudy-day.svg'); }\n.weather-icon.partly-cloudy-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/partly-cloudy-night.svg'); }\n.weather-icon.clear-day { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/clear-day.svg'); }\n.weather-icon.clear-night { background-image: url('https://raw.githubusercontent.com/visualcrossing/WeatherIcons/main/SVG/2nd%20Set%20-%20Color/clear-night.svg'); }\n\nfooter {\n    background-color: var(--gunmetal);\n    color: var(--white);\n    text-align: center;\n    padding: 1rem;\n    width: 100%;\n    margin-top: auto;\n}\n\n.social-links {\n    margin-top: 0.5rem;\n}\n\n.social-links a {\n    color: var(--robin-egg);\n    font-size: 1.5rem;\n    transition: color 0.3s ease;\n    text-decoration: none;\n    margin: 0 0.5rem;\n}\n\n.social-links a:hover {\n    color: rgba(78, 205, 196, 0.3);\n}\n\n@keyframes spin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Hide loader by default */\n.hidden {\n    display: none;\n}\n\n/* Desktop styles */\n@media (min-width: 768px) {\n    body {\n        padding: 2rem;\n    }\n\n    #app {\n        max-width: 800px;\n        padding: 2rem;\n    }\n\n    h1, h2 {\n        font-size: 1.8rem;\n    }\n\n    p {\n        font-size: 1.1rem;\n    }\n\n    .weather-gif img {\n        max-width: 80%;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
